import Techno from './Techno';
export default Techno;
